<template>
  <div>
    <el-form :model="formData" ref="formBroker" size="mini" :inline="true" label-width="100px">
      <el-form-item label="当前状态">
        <el-tag type="success" effect="plain" size="mini" v-if="formData.bool_exec === 1">已执行</el-tag>
        <el-tag type="warning" effect="plain" size="mini" v-else>未执行</el-tag>
        <el-button type="text" icon="el-icon-refresh-left"
                   v-if="formData.bool_exec === 1&& userAuth.rollback_exec_adv_order" @click="rollbackExec">撤回
        </el-button>
      </el-form-item>
      <el-form-item label="完成时间" prop="exec_timestamp">
        <template slot="label">
          <el-tooltip content="订单的执行时间：时间节点为每月3号" placement="top" effect="light">
            <div slot="content">
              <div style="font-weight: bold;font-size: 14px;margin-bottom: 5px">
                限制订单的执行时间：时间节点为每月<span style="color: red">{{ range.threshold_day }}日</span>
              </div>
              <div style="padding: 10px;border: #fe346e 1px dashed;border-radius: 5px;">
                <span style="font-weight: 600;font-size: 14px">
                  以{{ range.month }}月份为例：
                </span>
                <p style="padding-left: 5px;font-size: 12px">
                  {{ range.month }}月
                  <span style="color: red">{{ range.threshold_day }}日</span>之前，
                  可选执行完成时间范围：{{ range.logic.before.min|parseTime }}~{{ range.logic.before.max|parseTime }}；
                  <br/>
                  {{ range.month }}月
                  <span style="color: red">{{ range.threshold_day }}日</span>之后，
                  可选执行完成时间范围：{{ range.logic.after.min|parseTime }}~{{ range.logic.after.max|parseTime }}；<br/>
                </p>
              </div>
              <p v-html="rangeTip"/>
            </div>
            <span><i class="el-icon-info" style="color: #fe346e"></i> 完成时间</span>
          </el-tooltip>
        </template>
        <el-date-picker ref="refExecDatePacker" class="el-input-c" type="date"
                        v-model="formData.exec_timestamp"
                        value-format="yyyy-MM-dd"
                        format="yyyy年MM月dd日"
                        placeholder="选择执行完成时间" :disabled="!canExec" @change="handleChange"></el-date-picker>
      </el-form-item>
      <el-form-item v-if="userAuth.can_exec_adv_order">
        <el-button type="primary" icon="el-icon-finished" @click="onSubmit('formBroker')"
                   :disabled="loadingSubmit||!canCommit" v-if="canExec">
          {{ formData.bool_exec === 1 ? '纠正执行完成时间' : '执行完毕' }}
        </el-button>
      </el-form-item>
      <el-form-item v-if="!forceEditExecTime">
        <el-button type="text" icon="el-icon-edit-outline" round @click="forceEditExecTime=true"
                   v-if="userAuth.can_store_all_time_order">修改
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-tooltip class="item" effect="dark" content="【执行完毕】后，若需要修改【完成时间】，请联系财务部进行纠正"
                    placement="right">
          <el-button type="text" icon="el-icon-info" style="font-size: 1.2em"></el-button>
        </el-tooltip>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import {execOrder, rollBackExecOrder} from "@/api/order";
import moment from "moment";

/**
 * 时间范围对象
 * @typedef {Object} Range
 * @property {string} month - 03
 * @property {number} threshold_day - 时间节点阈值
 * @property {string} logic_by - before或after
 * @property {Object<{before: {min: string, max: string}, after: {min: string, max: string}}>} logic - before或after
 */
/**
 *
 * @param threshold_day
 * @returns {{logic_by: string, month: string, threshold_day: number, logic: {before: {min: string, max: string}, after: {min: string, max: string}}}}
 */
const calcRangeLogic = function (threshold_day = 3) {
  let logic_by
  /** ① 获取今天是几号 **/
  const today = moment().date(); // 返回数字类型（1-31）
  /** ② 获取当月开始时间 **/
  const start_of_month = moment().startOf('month').format('YYYY/MM/DD HH:mm:ss')
  const before_max = moment(moment(start_of_month).format(`YYYY/MM/${threshold_day}`)).subtract(1, 'day').format('YYYY/MM/DD 23:59:59')
  const after_max = moment().endOf('month').format('YYYY/MM/DD HH:mm:ss')
  const before_min = moment(start_of_month).subtract(1, 'month').format('YYYY/MM/DD')
  const after_min = start_of_month

  if (today < threshold_day) {
    // 之前
    logic_by = 'before'
  } else {
    // 之后
    logic_by = 'after'
  }

  return {
    // 时间节点：示例-每月3日
    threshold_day,
    // 逻辑依据
    logic_by,// before 或 after
    // 当前月
    month: moment().format('MM'),
    // 逻辑
    logic: {
      before: {min: before_min, max: before_max},
      after: {min: after_min, max: after_max},
    }
  }
}

/**
 * @param logic
 * @param logic_by
 * @returns {{now: string, start: string, end: string}}
 */
const getValidRange = function (logic, logic_by) {
  const now = moment().format('YYYY/MM/DD')
  const by = logic[logic_by]
  const start = moment(by.min).format('YYYY/MM/DD')
  const end = moment(by.max).format('YYYY/MM/DD')

  return {now, start, end}
}

// const valida
export default {
  name: "ExecForm",
  props: {
    formData: {
      type: Object
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
    currUser() {
      return this.$store.getters.getUser
    },
    //是否可修改
    canExec() {
      //时间还在当月
      return this.formData.bool_exec === 0 || this.forceEditExecTime
    },
    rangeTip() {
      const {now, start, end} = getValidRange(this.range.logic, this.range.logic_by)
      return `现在是${now},即 可选执行完成时间范围：<b>${start}~${end}</b>；<br/>`
    }
  },
  data() {
    return {
      loadingSubmit: false,
      forceEditExecTime: false,//强制修改执行时间
      range: calcRangeLogic(),
      canCommit: true
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    disabledDate(time) {
      return time.getTime() < Date.now() - 8.64e7; // 8.64e7 毫秒数代表一天
    },
    rollbackExec() {
      this.$msgbox.confirm(
          `确认撤回订单【ID：${this.formData.id}】执行状态吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        //撤回执行状态-仅仅超级管理员可操作
        rollBackExecOrder({id: this.formData.id}).then((res) => {
          if (res.success) {
            this.$notify.success('执行撤回成功')
            window.location.reload()
          }

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    onSubmit(refName) {
      this.$refs[refName].validate((valid) => {
        if (valid) {
          const releaseMonth = this.$utils.parseTime(this.formData.release_timestamp, '{y}-{m}')
          const execMonth = this.$utils.parseTime(this.formData.exec_timestamp, '{y}-{m}')
          if (execMonth !== releaseMonth) {
            this.$msgbox.confirm(
                "该笔订单发布时间为【" + this.formData.release_timestamp + "】与完成时间【" + this.formData.exec_timestamp + "】不在同一月份，确定提交吗",
                '提示',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
            ).then(() => {
              this.formSubmit()
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作'
              });
            });
          } else {
            this.formSubmit()
          }
        } else {
          return false;
        }
      })
    },
    formSubmit() {
      this.loadingSubmit = true
      let that = this
      let postData = {
        id: this.formData.id, // 订单ID
        exec_timestamp: this.formData.exec_timestamp, // 完成时间
        // publish_link: this.formData.publish_link, // 发布链接
      }
      execOrder(postData)
          .then(res => {
            if (res.success) {
              that.showToast({
                title: '提交成功',
                h: that
              })
            }
            this.forceEditExecTime = false
            this.loadingSubmit = false
            that.$emit('loadFormData')
          })
    },
    handleChange() {
      // 组织提示框
      let offset = 100
      if (this.$refs['refExecDatePacker']) {
        const element = this.$refs['refExecDatePacker'].$el;
        const rect = element.getBoundingClientRect();
        // eslint-disable-next-line no-console
        // this.$notify.info(`元素位置：左上角坐标(${rect.left}, ${rect.top})，右下角坐标(${rect.right}, ${rect.bottom})`);
        offset = Math.ceil(rect.top) || 100
      }
      const {start, end} = getValidRange(this.range.logic, this.range.logic_by)
      const start_end_str = `${start}~${end}`

      let msg = `合规日期范围：${start_end_str}`;
      // 检验是否合规
      if (this.formData.exec_timestamp) {
        const execDate = this.formData.exec_timestamp
        const bool = this.checkDateRange(execDate)

        if (bool) {
          this.canCommit = true
          msg = `恭喜，亲爱的“${this.currUser.name}”同学,完成时间为：${this.$utils.parseTime(execDate, '{y}年{m}月{d}日')}，符合规范执行时间（${start_end_str}），继续保持!`
        } else {
          //若不合规，看是否有任意修改的权限
          if (this.userAuth.can_store_all_time_order) {
            this.canCommit = true
            msg = `注意，亲爱的“${this.currUser.name}”同学,完成时间为：${this.$utils.parseTime(execDate, '{y}年{m}月{d}日')}，规范执行时间（${start_end_str}），虽有权限操作，但请谨慎！！！`
          } else {
            this.canCommit = false
            msg = `抱歉，亲爱的“${this.currUser.name}”同学,完成时间为：${this.$utils.parseTime(execDate, '{y}年{m}月{d}日')}，不符合规范执行时间（${start_end_str}），不支持操作!`
          }
        }

        this.$notify({
          type: this.canCommit ? 'success' : 'warning',
          title: '温馨提示',
          message: msg,
          offset: offset,
          position: 'top-left'
        })
      }
    },
    //检查指定的执行时间是否合规
    checkDateRange(execDate) {
      let {start, end} = getValidRange(this.range.logic, this.range.logic_by)
      end = moment(end).format('YYYY/MM/DD 23:59:59')
      return moment(start).isSameOrBefore(execDate) && moment(end).isSameOrAfter(execDate)
    },
  },
  created() {
  }
}
</script>

<style scoped>

</style>
